export enum SOCKET_WORKER_EVENTS {
    REQUEST_USER = "REQUEST_USER",
    RECEIVED_MESSAGE = "RECEIVED_MESSAGE",
    PRESENCE_ENTER = "PRESENCE_ENTER",
    PRESENCE_LEAVE = "PRESENCE_LEAVE",
    PRESENCE_OVERRIDE = "PRESENCE_OVERRIDE",
    SUBCHANNEL_MESSAGE = "SUBCHANNEL_MESSAGE",
    SUBCHANNEL_OVERRIDE = "SUBCHANNEL_OVERRIDE",
    SUBCHANNEL_ENTER = "SUBCHANNEL_ENTER",
    SUBCHANNEL_LEAVE = "SUBCHANNEL_LEAVE",
}

export enum SOCKET_AGENT_EVENTS {
    USER = "USER",
    BROADCAST = "BROADCAST",
    UPDATE_ID = "UPDATE_ID",
    SUBCHANNEL_CONNECT = "SUBCHANNEL_CONNECT",
    SUBCHANNEL_DISCONNECT = "SUBCHANNEL_DISCONNECT",
    SUBCHANNEL_MESSAGE = "SUBCHANNEL_MESSAGE",
    PRESENCE_REQUEST = "PRESENCE_REQUEST",
}

export enum SOCKET_EVENTS {
    NOTIFICATION = "NOTIFICATION",
    DELETE_NOTIFICATION = "DELETE_NOTIFICATION",
    KICK_REGISTER = "KICK_REGISTER",
    MEDIA_CENTER_UPDATE = "MEDIA_CENTER_UPDATE",
    WEBHOOK_EVENT = "WEBHOOK_EVENT",
    ROUTINE_SYNC = "ROUTINE_SYNC",
    DISTRIBUTE_ROUTINE_SYNC = "DISTRIBUTE_ROUTINE_SYNC",
    PRODUCT_INVENTORY_CHANGED = "PRODUCT_INVENTORY_CHANGED",
}
